import { useTranslation } from "@i18n";
import { TiArrowBackOutline } from "react-icons/ti";
import { DASHBOARD_ROUTE } from "@Helpers/urlHelpers";
import useGoBack from "@Services/hooks/useGoBack";
import nodata from "../../assets/images/Forbidden.svg";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import { BUTTON_TYPES } from "@CubeComponents/constants/globalVariable";
import { useUiNext } from "@Utils/uiNext";

/*
 * New UI: the illustration's box is its own width (Forbidden.svg is 609 wide; the image is 3/4 of the box), which is
 * px and so does not follow production's root (below 16 px at some widths). In the new UI the box is that width in
 * rem (609 / 16 = 38.0625rem, capped by the space as before), so a 16 px root draws exactly the same pixels. The
 * classic UI keeps its intrinsic box (flag off unchanged).
 */
const ILLUSTRATION_BOX_NEXT = "w-full max-w-[38.0625rem]";
/** New UI: the "Go back" icon's 20 px in rem, for the same reason. */
const BACK_ICON_SIZE_NEXT = "1.25rem";

function Forbidden() {
  const { t } = useTranslation();
  const goBack = useGoBack();
  const uiNext = useUiNext();

  return (
    <div className="flex w-full flex-col items-center overflow-hidden">
      <div
        className={`${uiNext ? `${ILLUSTRATION_BOX_NEXT} ` : ""}flex flex-col items-center justify-center text-center`}
      >
        <img src={nodata} alt="Forbidden 403" className="my-6 w-3/4" />
      </div>
      <div className="flex flex-col items-center justify-center">
        <span className="mb-2 text-2xl font-semibold text-[#7bd2fc]">{t("Sorry!")}</span>
        <span>{t("You do not have access to this page")}</span>
      </div>
      <ButtonComponent
        type="submit"
        buttonType={BUTTON_TYPES.BACKGROUND_BUTTON}
        className="mt-4"
        onClick={() => goBack(DASHBOARD_ROUTE)}
      >
        <span className="flex items-center">
          <TiArrowBackOutline size={uiNext ? BACK_ICON_SIZE_NEXT : 20} className="me-1" /> {t("Go back")}
        </span>
      </ButtonComponent>
    </div>
  );
}

export default Forbidden;
